import React from 'react'
import "./CTA.css"

export default function CTA() {
  return (
    <section className="cta">
      <h2>Let’s Create Something Beautiful Together</h2>
      <a href="https://wa.me/919999999999" className="btn-gold">
        Start Your Order
      </a>
    </section>
  );
}
